import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import {
  passosDoImpacto,
  PassoImpactoTipologias,
  PassoImpactoSistemistas,
} from "./AvisosImpactoN1";
import { IImpactoN1 } from "../../services/materiaisN1";

interface ModalLiberarCemProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  loading?: boolean;
  titulo: string; // "Disponibilizar Mercado"
  totalSelecionados: number;
  // FASE 05 — 2ª validação/PO 2026-07-24 (6.2): lista de códigos com status.
  codigosProdutos?: string[];
  /** Etapa D (itens 3 e 4): avisos de impacto exibidos acima da lista. */
  impacto?: IImpactoN1 | null;
}

export const ModalLiberarCem: React.FC<ModalLiberarCemProps> = ({
  open,
  onClose,
  onConfirm,
  loading = false,
  titulo,
  totalSelecionados,
  codigosProdutos = [],
  impacto,
}) => {
  // Assistente (itens A4-A6, 02/09): passos de aviso primeiro; a confirmação é o último passo.
  const passos = passosDoImpacto(impacto);
  const [indicePasso, setIndicePasso] = useState(0);
  useEffect(() => {
    if (open) setIndicePasso(0);
  }, [open]);
  const passoAtual = indicePasso < passos.length ? passos[indicePasso] : "confirmacao";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          // Itens A4-A6: largura para a tabela de avisos não rolar na horizontal.
          maxWidth: passoAtual === "confirmacao" ? "600px" : "900px",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Typography variant="h6">{titulo}</Typography>
        <IconButton onClick={onClose} size="small" disabled={loading}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {passoAtual === "tipologias" && (
        <PassoImpactoTipologias
          impacto={impacto!}
          onCancelar={onClose}
          onContinuar={() => setIndicePasso((p) => p + 1)}
        />
      )}

      {passoAtual === "sistemistas" && (
        <PassoImpactoSistemistas
          impacto={impacto!}
          onCancelar={onClose}
          onContinuar={() => setIndicePasso((p) => p + 1)}
        />
      )}

      {passoAtual === "confirmacao" && (
      <>
      <DialogContent dividers>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {/* FASE 05 — 2ª validação/PO 2026-07-24 (6.2): texto oficial do relatório. */}
          <Typography variant="body1">
            Todos os produtos que estavam na situação Homologado estarão disponíveis para uso
            dos clientes no software CEM. <strong>Deseja continuar?</strong> ({totalSelecionados}{" "}
            produto(s))
          </Typography>
          {codigosProdutos.length > 0 && (
            <Box
              sx={{
                maxHeight: 150,
                overflow: "auto",
                backgroundColor: "#f5f5f5",
                borderRadius: 1,
                p: 1,
                mt: 1,
              }}
            >
              {codigosProdutos.map((codigo, index) => (
                <Typography key={index} variant="body2">
                  {codigo}
                </Typography>
              ))}
            </Box>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} variant="outlined" disabled={loading}>
          CANCELAR
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={loading}
          sx={{ backgroundColor: "#3C90AD", "&:hover": { backgroundColor: "#2d6f87" } }}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : "CONFIRMAR"}
        </Button>
      </DialogActions>
      </>
      )}
    </Dialog>
  );
};

